import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useDealEstimationHeaders } from "~/hooks/vendors/deals/useDealEstimationHeaders";
import { useDealEstimationHistories } from "~/hooks/vendors/deals/useDealEstimationHistories";
import { useDealEstimations } from "~/hooks/vendors/deals/useDealEstimations";
import { useDeals } from "~/hooks/vendors/useDeals";
import { dealConstructionContext } from "~/models/DealConstruction";
import { estimationRequestSide } from "~/models/DealEstimationHeader";
import { PATH as ESTIMATIONS_PATH } from "~/pages/vendors/deals/[id]/estimations";
import { PATH as ESTIMATIONS_EDIT_PATH } from "~/pages/vendors/deals/[id]/estimations/edit";
import { ConstructionNavigation } from "./ConstructionNavigation";

type Props = {
	title: string;
};

export function ConstructionVendorNavigation({ title }: Props) {
	const dealId = useIdQueryHandler();
	const { data: deal } = useDeals().show(dealId);
	const { data: dealEstimationContext } = useDealEstimations().index(dealId);
	const { data: dealEstimationHistoryContext } =
		useDealEstimationHistories().index(dealId);
	const { data: dealEstimationHeaders } =
		useDealEstimationHeaders().index(dealId);
	const requestHeader =
		dealEstimationHeaders?.find((header) => header.status === "request") ??
		null;
	const { data: requestHistoryContext, isLoading } =
		useDealEstimationHeaders().show(dealId, requestHeader && requestHeader.id);
	if (
		dealId === null ||
		deal === null ||
		isLoading ||
		dealEstimationContext === null ||
		dealEstimationHistoryContext === null
	) {
		return null;
	}
	const requestSide = estimationRequestSide(deal, "vendor");
	return (
		<ConstructionNavigation
			dealConstructionContext={dealConstructionContext(
				false,
				requestSide,
				dealEstimationHistoryContext,
				requestHistoryContext,
				dealEstimationContext
			)}
			detailPagePath={
				requestSide ? ESTIMATIONS_EDIT_PATH(dealId) : ESTIMATIONS_PATH(dealId)
			}
			title={title}
		/>
	);
}
